import axios from "axios";

class Caba {
  constructor(props) {
    this.state = {
      api: "https://api-dot-caba-cpl.appspot.com",
      loggedIn: false,
      profile: null,
      token: "",
      scope: ""
    };
    // console.log("Caba constructed");
  }

  setProfile = profile => {
    this.profile = profile;
  };

  getProfile = () => {
    return this.profile;
  };

  getToken = () => {
    return this.state.token;
  };

  getScope = () => {
    return this.state.scope;
  };

  isAdmin = () => {
    return this.state.scope === "admin" ? true : false;
  };

  login = (token, profile) => {
    // console.log("Caba: token", token, profile);
    this.service = axios.create();
    this.profile = profile;
    this.token = token;

    return new Promise((resolve, reject) => {
      this.service
        .request({
          method: "POST",
          url: this.state.api + "/api/v1/login",
          responseType: "json",
          data: {
            id_token: token
          }
        })
        .then(response => {
          this.handleLogin(response, resolve);
        })
        .catch(error => {
          console.log("CABA Error", error);
          reject(error);
        });
    });
  };

  handleLogin = (response, resolve) => {
    let service = axios.create({
      headers: {
        Authorization: "Bearer " + response.data.token
      }
    });

    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;

    this.state.loggedIn = true;
    this.state.scope = response.data.scope;
    resolve(response);
  };

  handleToken = (response, callback) => {
    return this.service
      .request({
        method: "GET",
        url: this.state.api + "/api/v1/tokenInfo",
        responseType: "json"
      })
      .then(response => callback(response))
      .catch(error => console.log("error", error));
  };

  handleSuccess(response) {
    return response;
  }

  handleError = error => {
    console.log("error", error);
    this.notify("error", error.status, error.message);
    return Promise.reject(error);
  };

  redirectTo = (document, path) => {
    document.location = path;
  };

  get = path => {
    return new Promise((resolve, reject) => {
      this.service
        .get(this.state.api + path)
        .then(response => resolve(response))
        .catch(error => {
          reject();
          // this.handleError(error);
        });
    });
  };

  post = (path, payload) => {
    return new Promise((resolve, reject) => {
      this.service
        .request({
          method: "POST",
          url: this.state.api + path,
          responseType: "json",
          data: payload
        })
        .then(response => resolve(response))
        .catch(error => {
          reject();
          this.handleError(error);
        });
    });
  };

  put = (path, payload, callback) => {
    return new Promise((resolve, reject) => {
      this.service
        .request({
          method: "PUT",
          url: this.state.api + path,
          responseType: "json",
          data: payload
        })
        .then(response => resolve(response))
        .catch(error => {
          reject();
          this.handleError(error);
        });
    });
  };

  delete = (path, payload, callback) => {
    return new Promise((resolve, reject) => {
      this.service
        .request({
          method: "DELETE",
          url: this.state.api + path,
          responseType: "json",
          data: payload
        })
        .then(response => resolve(response))
        .catch(error => {
          reject();
          this.handleError(error);
        });
    });
  };

  isLoggedIn = () => {
    return this.state.loggedIn;
  };
}

export default new Caba();



// WEBPACK FOOTER //
// ./src/services/Caba.js